import PropTypes from "prop-types";

import { t } from "../../../../../services";
import { strCode } from "../../../../../consts";

import {
  FlexContainers,
  Heading5,
  Modal,
  Paragraph2,
  SmallButton,
  WrapperContainer
} from "../../../../../components";

const FeaturesDeactivatingModal = ({ isActive, onCancel, onDeactivating }) => {
  return (
    <Modal
      id="features-deactivating-modal"
      active={isActive}
      setActive={onCancel}
      modalHeader={<Heading5>{t(strCode.FEATURES_DEACTIVATING_TITLE)}</Heading5>}>
      <WrapperContainer
        Container={FlexContainers.FlexColumnStart}
        maxWidth={446}
        gap={24}
        alignItems="start">
        <Paragraph2>{t(strCode.FEATURES_DEACTIVATING_DESCRIPTION)}</Paragraph2>

        <WrapperContainer Container={FlexContainers.FlexRowEnd} gap={16} width="100%">
          <SmallButton onClick={onCancel} secondary>
            {t(strCode.CANCEL_BTN)}
          </SmallButton>

          <SmallButton onClick={onDeactivating} backgroundRed>
            {t(strCode.DISABLE_BTN)}
          </SmallButton>
        </WrapperContainer>
      </WrapperContainer>
    </Modal>
  );
};

FeaturesDeactivatingModal.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDeactivating: PropTypes.func.isRequired
};

export default FeaturesDeactivatingModal;
